import { CheckCircle } from "lucide-react"

const ExecutionItem = ({ id, type, description, score, action, time }) => {
  const getSignalColorClass = (signalType) => {
    if (signalType.includes("Risk")) return "#D83B5C"
    if (signalType.includes("Opp")) return "#4DC98B"
    return "#4179D4"
  }

  return (
    <div className="flex items-center justify-between text-sm py-1 border-b border-gray-200 last:border-b-0">
      <div className="flex items-center gap-2">
        <CheckCircle className="w-4 h-4 text-green-500" />
        <span className="font-semibold" style={{color: `${getSignalColorClass(type)}`}}>{type}:</span>
        <span>{description}</span>
      </div>
      <div className="text-right">
        <div className="text-xs">{action}</div>
        <div className="text-xs">{time}</div>
      </div>
    </div>
  )
}

export default ExecutionItem
